import { apiSlice } from "app/api/apiSlice"

export const absenceReportApiSlice = apiSlice.injectEndpoints({
    tagTypes: ['AbsenceRequest', 'MyAbsenceRequest', 'AbsenceStats', 'MyAbsenceStats', 'Overtimes', 'MyOvertimes'],
    endpoints: builder => ({
        getAbsenceReports: builder.query({
            query: () => 'hr/absencesReport',
            //keepUnusedDataFor: 5,
            providesTags: ['AbsenceRequest']
        }),
        getAbsenceReportsPaginated: builder.query({
            query: pageNumber => {
                return {
                    url: 'hr/absencesReportPaginated',
                    params: { page: pageNumber }
                }
            },
            //keepUnusedDataFor: 5,
            providesTags: ['AbsenceRequest']
        }),
        getEmployeeRequestsPaginated: builder.query({
            query: ({ userGUID, pageNumber }) => {
                return {
                    url: 'hr/employeeRequests',
                    params: {
                        userGUID: userGUID,
                        page: pageNumber
                    }
                }
            },
            //keepUnusedDataFor: 5,
            providesTags: ['AbsenceRequest']
        }),
        getPendingAbsenceRequests: builder.query({
            query: () => 'hr/absencesRequest/pending',
            keepUnusedDataFor: 60,
            providesTags: ['AbsenceRequest']
        }),
        getRequestsStats: builder.query({
            query: () => 'hr/absencesRequest/stats',
            providesTags: ['AbsenceRequest']
        }),
        getAbsenceStats: builder.query({
            query: interval => {

                const { start, end } = interval;
                return {
                    url: 'hr/utility/timeReport',
                    keepUnusedDataFor: 5,
                    params: { start: start, end: end }
                    //params: { start: 1693526400, end: 1696118399 }
                }
            },
            providesTags: ['AbsenceRequest','AbsenceStats']
        }),
        getMyAbsenceStats: builder.query({
            query: interval => {

                const { start, end } = interval;
                return {
                    url: 'hr/utility/timeReport/me',
                    keepUnusedDataFor: 5,
                    params: { start: start, end: end }
                    //params: { start: 1693526400, end: 1696118399 }
                }
            },
            providesTags: ['MyAbsenceStats']
        }),
        // getPostsByYear: builder.query < { start: string, end: string } > ({
        //     query: (arg) => {
        //         const { start, end } = arg;
        //         console.log('arg: ', arg);
        //         return {
        //             url: 'posts/',
        //             params: { start, end },
        //         };
        //     },
        // }),

        acceptRequest: builder.mutation({
            query: requestId => ({
                url: 'hr/absencesReport',
                method: 'PUT',
                body: {
                    guid: requestId,
                    newStatus: "ACCEPTED"
                }
            }),
            invalidatesTags: ['AbsenceRequest']
        }),
        declineRequest: builder.mutation({
            query: requestId => ({
                url: 'hr/absencesReport',
                method: 'PUT',
                body: {
                    guid: requestId,
                    newStatus: "DENIED"
                }
            }),
            invalidatesTags: ['AbsenceRequest']
        }),
        cancelRequest: builder.mutation({
            query: requestId => ({
                url: 'hr/absencesReport',
                method: 'PUT',
                body: {
                    guid: requestId,
                    newStatus: "CANCELED"
                }
            }),
            invalidatesTags: ['AbsenceRequest', 'MyAbsenceRequest']
        }),
        deleteRequest: builder.mutation({
            query: requestId => ({
                url: 'hr/absencesReport',
                method: 'PUT',
                body: {
                    guid: requestId,
                    newStatus: "DELETED"
                }
            }),
            invalidatesTags: ['AbsenceRequest']
        }),
        sendRequest: builder.mutation({
            query: ({ reason, startDate, endDate, note }) => ({
                url: 'hr/absencesReport',
                method: 'POST',
                body: {
                    type: reason,
                    startDate: startDate,
                    endDate: endDate,
                    note: note
                }
            }),
            invalidatesTags: ['MyAbsenceRequest']
        }),
        getMyAbsenceRequests: builder.query({
            query: pageNumber => ({
                url: 'hr/absencesReport/me',
                params: { page: pageNumber }
            }),
            keepUnusedDataFor: 60,
            providesTags: ['MyAbsenceRequest']
        }),

    })
})

export const {
    useGetAbsenceReportsQuery,
    useGetAbsenceReportsPaginatedQuery,
    useGetEmployeeRequestsPaginatedQuery,
    useGetPendingAbsenceRequestsQuery,
    useGetRequestsStatsQuery,
    useGetAbsenceStatsQuery,
    useGetMyAbsenceStatsQuery,
    useLazyGetAbsenceStatsQuery,
    useAcceptRequestMutation,
    useCancelRequestMutation,
    useDeclineRequestMutation,
    useDeleteRequestMutation,
    useSendRequestMutation,
    useGetMyAbsenceRequestsQuery
} = absenceReportApiSlice 